export default class Modal {
  constructor() {
    const modalOpenBtn = document.querySelectorAll('.js-modalOpen');
    const modalCloseBtn = document.querySelectorAll('.js-modalClose');

    modalOpenBtn.forEach((elm) => {
      elm.addEventListener('click', this.open);
    });

    modalCloseBtn.forEach((elm) => {
      elm.addEventListener('click', this.close);
    });
  }

  open(event) {
    event.preventDefault();
    // ボタンに付与されているaria-controlsの値を取得し、それと同じidが付与されているモーダルウィンドウを取得する
    const self = event.currentTarget || event.target;
    const targetId = self.getAttribute('aria-controls');
    const target = document.getElementById(targetId);
    const className = self.getAttribute('data-class');

    // モーダルが非表示だった場合
    if (target.getAttribute('aria-hidden') === 'true') {
      // ボタンのaria-expanded属性を変更し、対応するモーダルが開いたと設定する
      self.setAttribute('aria-expanded', 'true');
      // モーダルのaria-hidden属性を変更し、モーダルが開いたと設定する
      target.setAttribute('aria-hidden', 'false');
      // 現在のスクロール位置を取得した後、bodyを固定させる
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = -scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.classList.add(className);
    }
    return false;
  }

  close(event) {
    event.preventDefault();
    // ボタンに付与されているaria-controlsの値を取得し、それと同じidが付与されているモーダルウィンドウを取得する
    const self = event.currentTarget || event.target;
    let targetId = self.getAttribute('aria-controls');
    let target = document.getElementById(targetId);
    let className = self.getAttribute('data-class');
    let scrollY;

    // モーダルが表示されている場合
    if (target.getAttribute('aria-hidden') === 'false') {
      // 開くボタンクリック時に設定されたbodyのtopを取得し、bodyの固定を解除
      scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.classList.remove(className);
      // ボタンのaria-expanded属性を変更し、対応するモーダルが閉じたと設定する
      self.setAttribute('aria-expanded', 'false');
      // モーダルのaria-hidden属性を変更し、モーダルが閉じたと設定する
      target.setAttribute('aria-hidden', 'true');
      // スクロール位置をモーダルを開いた時と同じ位置に戻す
      window.scrollTo(0, parseInt(scrollY || '0') * -1);

      // 動画があれば一時停止
      if ( document.querySelector('.js-movie') ) {
        document.querySelector('.js-movie').pause();
      }
    }
    return false;
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new Modal();
});
